
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cart49ktQJeNt_45nuXcLfTg0wibIlYyikUNFgmnb4bduCS9oMeta } from "/opt/buildhome/repo/pages/cart.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as _91slug_93Q40qr2ACH7r8Jg_CrW1_45elk_45OlPzewwDXnFT0pDT8xAMeta } from "/opt/buildhome/repo/pages/recipe/[slug].vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    component: () => import("/opt/buildhome/repo/pages/cart.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "recipe-slug",
    path: "/recipe/:slug()",
    component: () => import("/opt/buildhome/repo/pages/recipe/[slug].vue")
  }
]